<script setup lang="ts">
const {
  currentSubscription,
  userCanManageSubscription,
  paymentInfoRequired,
  isWizardInitialized,
} = useSubscriptionApi();

const { createSettingsPath } = useSettingsRoute();
</script>
<template>
  <layout-dynamic-region-content region="banner">
    <banner-message
      v-if="
        userCanManageSubscription &&
        !isWizardInitialized &&
        (currentSubscription?.isTrialPeriod || paymentInfoRequired)
      "
      :theme="paymentInfoRequired ? 'red' : 'yellow'"
      class="text-xl flex gap-1"
    >
      <base-icon name="mdi:alert-outline" class="size-8" />
      <span v-if="currentSubscription?.isTrialPeriod">
        {{
          $t("cksetup.subscription.trialPeriodMessage", {
            date: $ck.utils.formatDateLabel(
              // TODO (BE): use renewal date instead of expiration date when available
              currentSubscription?.expirationDate,
              $i18n.locale,
            ),
          })
        }}
      </span>

      <nuxt-link
        v-if="paymentInfoRequired"
        class="underline capitalize p-1 text-nblue-1"
        :to="
          createSettingsPath({
            section: 'payment-method',
          })
        "
      >
        {{
          $t(`cksetup.subscription.paymentInfoRequiredMessage`, {
            date: $ck.utils.formatDateLabel(
              currentSubscription?.expirationDate,
              $i18n.locale,
            ),
          })
        }}
      </nuxt-link>
    </banner-message>
  </layout-dynamic-region-content>
</template>
